import { getBillingIntervalInMonths } from '@weft/services';
import type { BillingInterval, FixedPricing } from '@weft/types';
import { PRICING_MODELS } from '@weft/types';
import { isNotNullOrUndefined, isNullOrUndefined, raise } from '@weft/utils';

export function getFixedChargePrice(pricing: FixedPricing, billingInterval?: BillingInterval) {
  if (pricing.pricingModel === PRICING_MODELS.Commission) {
    return 0;
  }

  // Since subscription is acting as monthly charge, we need to multiply it by billingIntervalInMonths again
  const multiplier = isNotNullOrUndefined(billingInterval) ? getBillingIntervalInMonths(billingInterval) : 1;
  const price = pricing.priceConfiguration?.price * multiplier;

  if (isNullOrUndefined(price)) {
    return raise(`Price is undefined for fixed pricing: ${JSON.stringify(pricing, null, 2)}`);
  }

  return price;
}